import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 外部ETフォーム - 質問一覧取得
export async function getOutsideEntryFormOptions(id: string) {
  try {
    const path = "outsideEntryFormOptions";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 外部ETフォーム - 質問一覧編集
export async function putOutsideEntryFormOptions(editData: {
  [key: string]: any;
}) {
  try {
    const path = "outsideEntryFormOptions";
    const bodys = editData;
    const response = await axios.put(CONST.apiUrl2 + path, {
      bodys,
    });
    return { edit: response.data.edit, warning: response.data.warning || "" };
  } catch (error) {
    // logout();
  }
}

// 外部ETフォームフォーム詳細（メインテーブル） - 質問一覧取得
export async function getOutsideEntryFormOption(id: string) {
  try {
    const path = "outsideEntryFormOption";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string;
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: number | string;
    }[] = response.data.option_data;
    return { detail_data, option_data };
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 質問一覧編集時の依存サービス定義用サービス一覧取得
export async function getOutsideEntryFormOptionsDependServices(
  outside_entry_form_id: string
) {
  try {
    const path = "outsideEntryFormOptions/depend/services";
    const params = { outside_entry_form_id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    const outside_service_data: {
      outside_entry_form_service_id: number;
      outside_entry_form_service_name: string;
    }[] = response.data.outside_service_data;
    const fetch_product_key: string = response.data.product_key;
    return {
      outside_service_data,
      fetch_product_key,
    };
  } catch (error) {
    // logout();
    return {
      outside_service_data: [],
      fetch_product_key: "0",
    };
  }
}
